import React, { useEffect } from 'react';
import { connect } from '@giantmachines/redux-websocket';
import { useDispatch } from 'react-redux';
import { User } from '../../../tools';
import { chatActions } from '../../../redux/chat/actions';
import environments from '../../../environments';

const WsConnect = () => {
  const dispatch = useDispatch();
  const user = User.getUserInfo();

  useEffect(() => {
    if (user) {
      const wsUrl = `${environments.WEBSOCKET_URL}/${user.email.replace(/[^\p{L}]/gu, '')}/`;
      dispatch(connect(wsUrl));
      dispatch(chatActions.fetchChannels());
    }
  }, [user]);
  return <></>;
};

export default WsConnect;
